export default function updateArrowPosition(slideIndex)
{

    // Get teh arrow
    const $arrow = $('#product-details').find('.arrow')

    // Get the slide width
    const slideWidth = $('.swiper-slide.swiper-slide-active').width()

    // Get the slide margin
    const slideMargin = parseInt($('.swiper-slide:first-child').css('marginRight'))

    // Align the arrow
    $arrow.css({left: slideWidth * (slideIndex + 1) + slideMargin * slideIndex - $arrow.width() / 2 - slideWidth / 2})

}
